import {NgModule} from '@angular/core';
import {EeConfigPage} from './page/ee-config/ee-config.page';
import {EeDashboardPage} from './page/ee-dashboard/ee-dashboard.page';
// TM-1000001721 — object pages
import {EeExportTypeObjectPage} from './page/object/ee-export-type-object-page/ee-export-type-object.page';
import {EeStructureObjectPage} from './page/object/ee-structure-object-page/ee-structure-object.page';
import {EeExportObjectPage} from './page/object/ee-export-object-page/ee-export-object.page';
// TM-1000001727: P8b — neue Object-Pages
import {
    EeExportHookBindingObjectPage
} from './page/object/ee-export-hook-binding-object-page/ee-export-hook-binding-object.page';
// TM-1000001721 — object detail components
import {
    EeExportTypeObjectComponent
} from './component/object-components/ee-export-type-object-component/ee-export-type-object.component';
import {
    EeStructureObjectComponent
} from './component/object-components/ee-structure-object-component/ee-structure-object.component';
import {
    EeExportObjectComponent
} from './component/object-components/ee-export-object-component/ee-export-object.component';
// TM-1000001727: P8b — neue Object-Component
import {
    EeExportHookBindingObjectComponent
} from './component/object-components/ee-export-hook-binding-object-component/ee-export-hook-binding-object.component';
import {EE_ENTITY_PROVIDER} from './ee.entity-provider';
import {CoreModule} from '../../core/core.module';

@NgModule({
    declarations: [
        EeConfigPage,
        EeDashboardPage,
        // TM-1000001721 — object pages
        EeExportTypeObjectPage,
        EeStructureObjectPage,
        EeExportObjectPage,
        // TM-1000001727: P8b — Pages
        EeExportHookBindingObjectPage,
        // TM-1000001721 — object detail components
        EeExportTypeObjectComponent,
        EeStructureObjectComponent,
        EeExportObjectComponent,
        // TM-1000001727: P8b — Object-Component
        EeExportHookBindingObjectComponent,
    ],
    exports: [
        EeConfigPage,
        EeDashboardPage,
        // TM-1000001721 — object pages
        EeExportTypeObjectPage,
        EeStructureObjectPage,
        EeExportObjectPage,
        // TM-1000001727: P8b — Pages
        EeExportHookBindingObjectPage,
        // TM-1000001721 — object detail components
        EeExportTypeObjectComponent,
        EeStructureObjectComponent,
        EeExportObjectComponent,
        // TM-1000001727: P8b — Object-Component
        EeExportHookBindingObjectComponent,
    ],
    imports: [
        CoreModule
    ],
    providers: [EE_ENTITY_PROVIDER]
})
export class EeModule {
}
